export default {
  getTdWidth (item) {
    return (item.width + '').match('%$') ? item.width : Number(item.width) + 'px'
  },
  stableSort: function (arr, fn) {
    let nArr = arr.map((v, i) => {
      return {v: v, i: i}
    })
    return nArr.sort(fn).map( v => {
      return v.v
    })
  },
  on: function(e, selector, isTargetFunc, cb) {

    isTargetFunc = isTargetFunc || function () {return true}

    selector.addEventListener(e, function(e) {
      let cTarget = e.target
      while (cTarget != selector) {
        if (isTargetFunc(cTarget)) {
          cb(e, cTarget)
          return
        }
        cTarget = cTarget.parentElement
      }
    })
  },
  extend: (function() {
    let isObjFunc = function(name) {
        let toString = Object.prototype.toString
        return function() {
            return toString.call(arguments[0]) === '[object ' + name + ']'
        }
    }
    let isObject = isObjFunc('Object'),
        isArray = isObjFunc('Array'),
        isBoolean = isObjFunc('Boolean')
    return function extend() {
        let index = 0,
            isDeep = false,
            obj, copy, destination, source, i
        if (isBoolean(arguments[0])) {
            index = 1
            isDeep = arguments[0]
        }
        for (i = arguments.length - 1; i > index; i--) {
            destination = arguments[i - 1]
            source = arguments[i]
            if (isObject(source) || isArray(source)) {
                for (let property in source) {
                    obj = source[property]
                    if (isDeep && (isObject(obj) || isArray(obj))) {
                        copy = isObject(obj) ? {} : []
                        let extended = extend(isDeep, copy, obj)
                        destination[property] = extended
                    } else {
                        destination[property] = source[property]
                    }
                }
            } else {
                destination = source
            }
        }
        return destination
    }
  })(),
  isNum: function (v) {
    if (v === null) return false
    return !isNaN( v - 0 )
  },
  Warning : function(text){
    if(!console) return;
    console.warn('HQData:' + text);
  },
  Wrong : function(text){
    if(!console) return;
    console.error('HQData:' + text);
  },
  addClass : function(originClassName,className){
	const reg = new RegExp(className,'g')
    return originClassName.replace(reg,'').replace(/(\s)*$/,"") + ' ' + className
  },
  removeClass : function(originClassName,className){
	const reg = new RegExp(className,'g')
	return originClassName.replace(reg,'')
  },
  hasClass : function(originClassName,className){
	if(originClassName.indexOf(className) > -1){
	  return true	
	}
	return false
  }
}



// WEBPACK FOOTER //
// ./src/lib/v-hqtable/lib/util.js